import { useEffect, useState } from 'react';
import { createImageObjectUrl, isObjectUrl } from '@_/utils-frontend';

interface UseImageObjectUrlOptions {
  value: File | string | null;
}

export function useImageObjectUrl({ value }: UseImageObjectUrlOptions) {
  const [imageUrl, setImageUrl] = useState<string | null>();

  useEffect(() => {
    void (async () => {
      let newUrl: string | null;
      if (value instanceof File) {
        newUrl = await createImageObjectUrl(value);
      } else {
        newUrl = value;
      }

      setImageUrl(currentUrl => {
        if (currentUrl && isObjectUrl(currentUrl)) {
          URL.revokeObjectURL(currentUrl);
        }
        return newUrl;
      });
    })();
  }, [value]);

  return imageUrl;
}
